import React from "react";
import { Button, Column, Columns, Modal, Section, Title } from "@allxsmith/bestax-bulma";



export default function VehicleMileageWarning({open, setOpen, job}){

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
          closeOnBlur
          active={open}
          onClose={() => {
            setOpen(false);
          }}
        >
            <Modal.Content>
                <Section style={{ backgroundColor: "white" }}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Vehicle Mileage Warning</Title>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <p>This vehicle is approaching its mileage
                                limit {job.vehicle ? job.vehicle.model ? "of " + job.vehicle.model.mileage_limit : "" : ""}</p>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                           <Button
                                color={"info"}
                                onClick={(e) => setOpen(false)}
                                isFullWidth
                            >
                                Close
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );


}